export const DEFAULT_DAYS = [
  "Sunday",
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
];

export const DEFAULT_FROM_TIME = { hour: "6", minute: "00", period: "AM" };
export const DEFAULT_TO_TIME = { hour: "6", minute: "00", period: "PM" };

export const DEFAULT_SCHEDULE = {
  daysEnabled: false,
  timeEnabled: false,
  days: [...DEFAULT_DAYS],
  fromTime: { ...DEFAULT_FROM_TIME },
  toTime: { ...DEFAULT_TO_TIME },
};

export const convertToMinutes = (hour, minute, period) => {
  let h = parseInt(hour);
  if (period === "PM" && h !== 12) h += 12;
  if (period === "AM" && h === 12) h = 0;
  return h * 60 + parseInt(minute);
};

export const isValidTimeRange = (fromTime, toTime) => {
  const fromMinutes = convertToMinutes(fromTime.hour, fromTime.minute, fromTime.period);
  const toMinutes = convertToMinutes(toTime.hour, toTime.minute, toTime.period);
  return toMinutes > fromMinutes;
};

export const getNextValidTime = (time) => {
  const minuteNum = parseInt(time.minute);
  const hourNum = parseInt(time.hour);

  if (minuteNum < 59) {
    return {
      hour: time.hour,
      minute: (minuteNum + 1).toString().padStart(2, "0"),
      period: time.period,
    };
  }

  if (hourNum === 12) {
    return { hour: "1", minute: "00", period: time.period === "AM" ? "PM" : "AM" };
  }
  if (hourNum === 11) {
    return { hour: "12", minute: "00", period: time.period };
  }
  return { hour: (hourNum + 1).toString(), minute: "00", period: time.period };
};

export const getValidToHours = (fromTime, toPeriod, allHours) => {
  const fromMinutesTotal = convertToMinutes(fromTime.hour, fromTime.minute, fromTime.period);
  return allHours.filter((h) => {
    const testMaxMinutes = convertToMinutes(h, "59", toPeriod);
    return testMaxMinutes > fromMinutesTotal;
  });
};

export const getValidToMinutes = (fromTime, toHour, toPeriod, allMinutes) => {
  const fromMinutesTotal = convertToMinutes(fromTime.hour, fromTime.minute, fromTime.period);
  return allMinutes.filter((m) => {
    const toMinutesTotal = convertToMinutes(toHour, m, toPeriod);
    return toMinutesTotal > fromMinutesTotal;
  });
};

export const getValidToPeriods = (fromPeriod, allPeriods) => {
  if (fromPeriod === "AM") return allPeriods;
  return allPeriods.filter((p) => p === "PM");
};

export const getDaysStatusText = (selectedDays) => {
  if (!selectedDays || selectedDays.length === 0) return "No days selected";
  if (selectedDays.length === 7) return "Every day";
  const abbreviated = selectedDays.map((d) => d.slice(0, 2));
  return abbreviated.join(", ");
};

export const getTimeStatusText = (fromTime, toTime) => {
  const fmt = (t) => `${t.hour}:${t.minute} ${t.period}`;
  return `${fmt(fromTime)} – ${fmt(toTime)}`;
};

export const getScheduleSummary = (schedule) => {
  if (!schedule) return "Every day, all hours";
  const { daysEnabled, timeEnabled, days, fromTime, toTime } = schedule;
  if (!daysEnabled && !timeEnabled) return "Every day, all hours";
  const parts = [];
  if (daysEnabled) parts.push(getDaysStatusText(days));
  if (timeEnabled) parts.push(getTimeStatusText(fromTime, toTime));
  else parts.push("all hours");
  return parts.join(", ");
};

export const formatRuleScheduleSummary = (daysOfTheWeek, starttime, endtime) => {
  if (!daysOfTheWeek?.length && !starttime) return "Always active";
  const parts = [];
  if (daysOfTheWeek?.length) {
    const abbrevs = daysOfTheWeek.map((d) => d.charAt(0) + d.slice(1, 2).toLowerCase());
    parts.push(abbrevs.length === 7 ? "Every day" : abbrevs.join(", "));
  }
  if (starttime && endtime) {
    const fmt = (iso) => iso.split("T")[1]?.replace(":00Z", "") ?? iso;
    parts.push(`${fmt(starttime)} – ${fmt(endtime)} UTC`);
  }
  return parts.join(", ");
};
